document.addEventListener('DOMContentLoaded', () => {
    const mediaGallery = document.querySelector('media-gallery');

    if (!mediaGallery) return;

    // Original Methode sichern
    const originalSetActiveMedia = mediaGallery.setActiveMedia;

    // Überschreiben
    mediaGallery.setActiveMedia = function () {
        // 👉 nichts tun → verhindert Fokus + Scroll + Reflow
        return;
    };
});